import axios from 'axios';
import gpsevaluationtimeEscl from '../locales/es-CL/gpsevaluationtime.json';
import gpsevaluationtimeEsmx from '../locales/es-MX/gpsevaluationtime.json';
import gpsevaluationtimeEsco from '../locales/es-CO/gpsevaluationtime.json';
import gpsevaluationtimeEnus from '../locales/en-US/gpsevaluationtime.json';
import showAlert from '../alert/alertHandler';

export default {
  name: 'gpsevaluationtime',
  i18n: {
    messages: {
      'es-CL': {
        gpsevaluationtime: gpsevaluationtimeEscl,
      },
      'es-MX': {
        gpsevaluationtime: gpsevaluationtimeEsmx,
      },
      'es-CO': {
        gpsevaluationtime: gpsevaluationtimeEsco,
      },
      'en-US': {
        gpsevaluationtime: gpsevaluationtimeEnus,
      },
    },
  },
  data() {
    return {
      optionsBefore: [
        { value: 3600, text: '1 hrs' },
        { value: 10800, text: '3 hrs' },
        { value: 21600, text: '6 hrs' },
        { value: 43200, text: '12 hrs' },
        { value: 86400, text: '24 hrs' },
        { value: 172800, text: '48 hrs' },
      ],
      optionsAfter: [
        { value: 3600, text: '1 hrs' },
        { value: 10800, text: '3 hrs' },
        { value: 21600, text: '6 hrs' },
        { value: 43200, text: '12 hrs' },
        { value: 86400, text: '24 hrs' },
        { value: 172800, text: '48 hrs' },
      ],
      optionsRouteLifeTime: [
        { value: 3600, text: '1 hrs' },
        { value: 10800, text: '3 hrs' },
        { value: 86400, text: '24 hrs' },
        { value: 172800, text: '48 hrs' },
        { value: 259200, text: '72 hrs' },
      ],
      selectedOptionBefore: null,
      selectedOptionAfter: null,
      selectedOptionRouteLifeTime: null,
      showInformativeWindow: true,
    };
  },
  async created() {
    const urlClients = this.$store.getters.urlAPI + '/clientparam/client/' + this.$store.getters.clientId;
    try {
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const response = await axios.get(urlClients, config);
      this.selectedOptionBefore = this.optionsBefore.filter(function (hours) {
        return hours.value === +response.data.data.parameters.before;
      })[0].value;
      this.selectedOptionAfter = this.optionsAfter.filter(function (hours) {
        return hours.value === +response.data.data.parameters.after;
      })[0].value;
      this.selectedOptionRouteLifeTime = this.optionsRouteLifeTime.filter(function (hours) {
        return hours.value === +response.data.data.parameters.routelifetime;
      })[0].value;
    } catch (e) {
      if (e.response.status === 404) {
        this.selectedOptionBefore = this.optionsBefore.filter(function (hours) {
          return hours.value === +e.response.data.data.parameters.before;
        })[0].value;
        this.selectedOptionAfter = this.optionsAfter.filter(function (hours) {
          return hours.value === +e.response.data.data.parameters.after;
        })[0].value;
        this.selectedOptionRouteLifeTime = this.optionsRouteLifeTime.filter(function (hours) {
          return hours.value === +e.response.data.data.parameters.routelifetime;
        })[0].value;
      } else {
        console.log(e);
      }
    }
  },
  methods: {
    closeInformativeWindow() {
      this.showInformativeWindow = false;
    },
    async saveChanges() {
      try {
        const url = this.$store.getters.urlAPI + '/clientparam';
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = {
          idClient: this.$store.getters.clientId,
          parameters: {
            before: this.selectedOptionBefore,
            after: this.selectedOptionAfter,
            routelifetime: this.selectedOptionRouteLifeTime,
          },
        };
        const responsePost = await axios.post(url, body, config);
        console.log(responsePost.data.message);
        if (responsePost.data.message == 'El cliente ya tiene un registro activo de parametros') {
          const urlPatch = this.$store.getters.urlAPI + '/clientparam/' + responsePost.data.data.id;
          const responsePatch = await axios.patch(urlPatch, body, config);
          console.log(responsePatch);
        }
        showAlert(
          this.$t('gpsevaluationtime.alertMessages.success.title'),
          this.$t('gpsevaluationtime.alertMessages.success.message'),
        );
      } catch (e) {
        console.log(e);
      }
    },
  },
};
